/* ExportAction.js */

"use strict";
// const Registrations = require("../../../../../RegistrationNamespaces");
const FileName = require("@gluenetworks/steve_utilities").fileName;

const _ = require("lodash");
// const moment = require("moment-timezone");
class ExportAction {
    constructor(
        logger,
        gameEditor,
        modalUserFeedback,
        ExplorerTemplate,
        userSession,
        activeView,
        steveIo,
        Explorables
    ) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._templateEntity = ExplorerTemplate;
        this._explorablesEntityDef = Explorables;
        this._explorerTemplate = new ExplorerTemplate(userSession.activeOrganization.id);
        this._flattenedPaths = {};

        this._modalUserFeedback = modalUserFeedback;
        this._activeView = activeView;
        this._fileFactory = steveIo.fileFactory;
        this._fileNamer = FileName;
        this._activeOrgId = userSession.activeOrganization.id;
        this.run = this.run.bind(this);
    }

    generateLabelsMap(obj, label = "") {
        let res = {};
        Object.keys(obj).forEach((key) => {
            let pathLabel = label;
            if (obj[key].path) {
                res[obj[key].path] = pathLabel + key;
            } else {
                pathLabel += key + ">";
                res = Object.assign(res, this.generateLabelsMap(obj[key], pathLabel));
            }
        });
        return res;
    }

    run() {
        let entityIds = this._activeView.getSelectedPlanIds().selectedRows;
        let entities;
        const exportProperties = [
            "name",
            "description",
            "shared",
            "private",
            "defaultForDm",
            "defaultForCda",
            "defaultForOsm",
            "columns",
            "rowOrientedProp",
        ];

        if (_.isEmpty(entityIds)) {
            return;
        }
        // console.log(entityIds);
        // const _cDate = new Date();
        // const timeZone = moment.tz.guess();
        // _fileNameTime = moment.tz(_cDate.toISOString(), timeZone).format("YYYYMMDD_HHmmss_z");
        this._explorablesEntityDef
            .loadExplorables(this._activeOrgId)
            .then((explorables) => {
                this._explorablesEntity = explorables;
                this._flattenedPaths = this.generateLabelsMap(
                    this._explorablesEntity.getExplorables()
                );
                return this._templateEntity.loadAscendExplorerTemplates(this._activeOrgId, {
                    $and: [{id: {$in: entityIds}}],
                });
            })
            .then((ets) => {
                entities = ets;
                const result = ets.map((et) => {
                    let _et = _.pick(et, exportProperties);
                    if (_et.columns && _et.columns.length > 0) {
                        _et.columns.forEach((column) => {
                            if (!column.flattenedPath && this._flattenedPaths[column.path]) {
                                column.flattenedPath = this._flattenedPaths[column.path];
                            }
                        });
                    }
                    return _et;
                });
                return result;
            })
            .then((result) => {
                let specificPart = "MultipleTemplates";
                if (entityIds.length === 1) {
                    specificPart = entities[0].name;
                }
                const fileName = this._fileNamer({
                    solution: "DE",
                    general: "Template",
                    specific: specificPart,
                    suffix: "json",
                });

                this._fileFactory.saveJsonAsFile(JSON.stringify(result), fileName);
                return Promise.resolve();
            })
            .catch((err) => {
                this._logger.warn("Template Export Error :: ", err);
            });
    }
}

module.exports = ExportAction;

ExportAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.ui.userFeedback",
    "$teve.entities.ExplorerTemplate",
    "$teve.userSession",
    "gameEditor.activeView",
    "$teve.io",
    "$teve.entities.Explorables",
];

ExportAction.$displayDetails = {
    type: "Action",
    name: "ExportAction",
    icon: "configdrift.export_devices",
    shown: true,
    title: "Export templates",
    order: 4,
};
